import { render, staticRenderFns } from "./auxilioAluguel.vue?vue&type=template&id=54bf491c&"
import script from "./auxilioAluguel.vue?vue&type=script&lang=js&"
export * from "./auxilioAluguel.vue?vue&type=script&lang=js&"
import style0 from "./auxilioAluguel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports